export default __webpack_public_path__ + "static/Logo_0X01-cc85791c809c91eb42e09d761a8a5eb9.png";